import gqlApi from '../../api/gql'

// initial state
const state = () => ({

  blogCategories: [],
  blogCategoriesUiMeta: [],
  blogCategory: {},

  blogs: [],
  blogsUiMeta: [],
  blog: {},
})

// getters
const getters = {}

// actions
const actions = {
  listBlogCategories({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListBlogCategories{
            invisible_id
            name
            image_url
            sequence
            i18n_status
            created_at
            updated_at
          }
        }
      `,
      variables: {
        name: 'BlogCategoryListVo',
      }
    }).then(data => {
      commit('set', ['blogCategoriesUiMeta', data.GetUiMeta])
      commit('setBlogCategories', data.ListBlogCategories)
      return true
    })
  },

  getBlogCategory({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetBlogCategory(id: $id){
            created_at
            description
            id
            image_url
            name
            parent_id
            sequence
            status
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setBlogCategory', resp.GetBlogCategory)
      return true
    })
  },

  updateBlogCategory(_, blogCategory) {
    return gqlApi.query({
      query: `    
        mutation($input: BlogCategoryUpdateVo){
          UpdateBlogCategory(input: $input){
            id
          }
        }
      `,
      variables: {
        input: blogCategory,
      },
    }).then(() => {
      return true
    })
  },

  addBlogCategory(_, blogCategory) {
    return gqlApi.query({
      query: `    
        mutation($input: BlogCategoryAddVo){
          AddBlogCategory(input: $input){
            id
          }
        }
      `,
      variables: {
        input: blogCategory,
      },
    }).then(() => {
      return true
    })
  },

  deleteBlogCategory(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteBlogCategory(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },

  listBlogs({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListBlogs{
            invisible_id
            title
            i18n_status
            sequence
            image_url
            category
            publish_date
            updated_at
          }
        }
      `,
      variables: {
        name: 'BlogListVo',
      }
    }).then(data => {
      commit('set', ['blogsUiMeta', data.GetUiMeta])
      commit('setBlogs', data.ListBlogs)
      return true
    })
  },
  getBlog({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetBlog(id: $id){
            category_id
            created_at
            content
            id
            image_url
            title
            status
            sequence
            publish_date
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setBlog', resp.GetBlog)
      return true
    })
  },
  updateBlog(_, blog) {
    return gqlApi.query({
      query: `    
        mutation($input: BlogUpdateVo){
          UpdateBlog(input: $input){
            id
          }
        }
      `,
      variables: {
        input: blog,
      },
    }).then(() => {
      return true
    })
  },
  addBlog(_, blog) {
    return gqlApi.query({
      query: `    
        mutation($input: BlogAddVo){
          AddBlog(input: $input){
            id
          }
        }
      `,
      variables: {
        input: blog,
      },
    }).then(() => {
      return true
    })
  },
  deleteBlog(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteBlog(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },
}

// mutations
const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  setBlogCategories (state, blogCategories) {
    state.blogCategories = blogCategories
  },
  setBlogCategory (state, blogCategory) {
    state.blogCategory = blogCategory
  },
  setBlogs (state, blogs) {
    state.blogs = blogs
  },
  setBlog (state, blog) {
    state.blog = blog
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}